<template>
    <BasePopup closeType="stayOnPage" width="700" @clickToClose="clickToClose">
        <template v-if="isLoaded != false">        
            <header>
                <font-awesome-icon icon="fa-solid fa-cart-circle-arrow-up" style="color: #28bc6d;"/>
                <span v-if="route.name == 'productOrderBumpEdit'"  class="ms-2 align-middle">Editar order bump</span>
                <span v-else class="ms-2 align-middle">Novo order bump</span>
            </header>
            <div>
                <form @submit.prevent="">
                    <div class="row">
                        <BaseSelect
                            class="col-12 mb-3"
                            id="id_product_bump"
                            label="Produto"
                            :items="productsList"
                            aria-placeholder="Selecione"
                            placeholder="Selecione"
                            :page="route.name"
                            v-model="bump.id_product_bump"
                        />
                    </div>
                    <BaseButton @click="submit" class="btn-success w-100 mt-4" :disabled="isLoading">
                        Salvar
                    </BaseButton>
                </form>
            </div>
        </template>
    </BasePopup>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue'
import { storeToRefs } from 'pinia';
import { useRoute, useRouter} from 'vue-router'
import { useProductStore } from "@/stores/products";
import { useGlobalStore } from '@/stores/global';

const productStore = useProductStore();
const { bump }  = storeToRefs(productStore); 
const globalStore = useGlobalStore();

const route = useRoute();
const router = useRouter();

const productsList = ref({})
const isLoaded = ref(false)
const isLoading = ref(false);

const product_id = computed (function () {
    return route.params.id;
});

onBeforeMount(() =>{
    if(productStore.product.id){
        for(let i = 0; i < productStore.all_products.length; i++){
            productsList.value[productStore.all_products[i].id] = productStore.all_products[i].title  + [productStore.all_products[i].tag !== null ? ' ('+ productStore.all_products[i].tag +')' : ''];
        }
    }
    if(route.name == 'productOrderBumpEdit'){
        if(productStore.bump.id == undefined || productStore.bump.id == null){
            globalStore.loader('show')
            productStore.tryOrderBump(route.params.slug).then(() =>{
                isLoaded.value = true;
                globalStore.loader('hide')
            })
        } else {
            isLoaded.value = true
        }
    } else if(route.name == 'productOrderBumpCreate') {
        globalStore.cleanObject(productStore.bump);
        isLoaded.value = true
    }
})

let previousPage = router.options.history.state.back;

function clickToClose() {
    router.push(previousPage)
}

function submit(){
    if(!isLoading.value){
        isLoading.value = true;
        globalStore.loader('show')
        if(route.name == 'productOrderBumpEdit'){
            let params = ['id_product_bump'];

            productStore.tryUpdateOrderBump(params, route.name, productStore.bump.id).then(function(success) {
                if(success){
                    useGlobalStore().successMessage('Order bump atualizado com sucesso');

                    productStore.tryOrdersBumps().then(function(success){
                        if(success){
                            globalStore.loader('hide');
                            router.push('/products/' + product_id.value + '/bump')
                        } else{
                            globalStore.loader('hide');
                        }
                    })
                }
                isLoading.value = false;
            });
        } else if(route.name == 'productOrderBumpCreate') {
            let params = ['id_product_bump'];

            productStore.tryCreateOrderBump(params, route.name).then(function(success){
                if(success){
                    useGlobalStore().successMessage('Order bump criado com sucesso');

                    productStore.tryOrdersBumps().then(function(success) {
                        if(success){
                            globalStore.loader('hide');
                            router.push('/products/' + product_id.value + '/bump')
                        } else {
                            globalStore.loader('hide');
                        }
                    });
                }else {
                    globalStore.loader('hide');
                }
                isLoading.value = false;
            })
        }
    }
}

</script>